import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { EnvironmentService } from '@mt-ng2/environment-module';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { AuthService } from '@mt-ng2/auth-module';

import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { PageTitlesService } from '@mt-ng2/page-titles';
import { LoginConfig } from '@mt-ng2/login-module';
import { ForgotUsernameService } from './forgot-username.service';

@Component({
    selector: 'app-forgot-username',
    templateUrl: './forgot-username.component.html',
})
export class ForgotUsernameComponent implements OnInit {
    forgotUsernameForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });

    logoFull: string;

    protected authService: AuthService;
    protected notificationsService: NotificationsService;
    protected environmentService: EnvironmentService;
    public config: LoginConfig;
    protected pageTitlesService: PageTitlesService;
    private ForgotUsernameService: ForgotUsernameService;

    constructor(injector: Injector) {
        this.authService = injector.get(AuthService);
        this.notificationsService = injector.get(NotificationsService);
        this.environmentService = injector.get(EnvironmentService);
        this.config = injector.get(LoginConfig);
        this.pageTitlesService = injector.get(PageTitlesService);
        this.ForgotUsernameService = injector.get(ForgotUsernameService);
        this.logoFull = `${this.environmentService.config.assetsPath}logo-full.png`;
    }

    ngOnInit(): void {
        // appReady determines if an authenticated connection has been made.
        // While it's waiting it shows a loading icon.  When appReady has a
        // value the loading icon is hidden.  We always want this to be true
        // when you are on the login page.  Because you aren't authed!
        if (this.authService.appReady && !this.authService.appReady.getValue()) {
            this.authService.appReady.next(true);
        }
        this.setPageTitle();
    }

    setPageTitle(): void {
        this.pageTitlesService.setPageTitle('Forgot Username');
    }

    emailHasError(): boolean {
        const control = this.forgotUsernameForm.get('email');
        return control.errors && (control.touched || control.errors.maxlength);
    }

    showEmailRequiredError(): boolean {
        const control = this.forgotUsernameForm.get('email');
        return control.touched && control.hasError('required');
    }

    showEmailInvalidError(): boolean {
        const control = this.forgotUsernameForm.get('email');
        return control.touched && control.hasError('email');
    }

    onSubmit(): void {
        if (this.forgotUsernameForm.valid) {
            const values = this.forgotUsernameForm.value;
            this.ForgotUsernameService.requestUsernameEmail(values.email).subscribe(
                (success) => {
                    this.notificationsService.success(`Username has been sent successfully. Please check your email.`);
                },
                (error) => this.notificationsService.error('Sending email failed. Please try again later.'),
            );
        } else {
            markAllFormFieldsAsTouched(this.forgotUsernameForm);
        }
    }
}
